import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
export function PixelGridRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area.toTransferable(),
        datetime: DateTime_toTransferable(req.datetime),
        boundingBoxLimit: req.boundingBoxLimit ? req.boundingBoxLimit.toTransferable() : null,
    };
}
export function PixelGridRequest_fromTransferable(req) {
    return {
        ...req,
        area: Area.fromTransferable(req.area),
        datetime: DateTime_fromTransferable(req.datetime),
        boundingBoxLimit: req.boundingBoxLimit ? Area.fromTransferable(req.boundingBoxLimit) : null,
    };
}
export function toGridRequest(grid) {
    // the backend automatically performs the `Point` -> `Area` transformation.
    return { ...grid };
}
//# sourceMappingURL=PixelGridRequest.js.map